import React from "react";
import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);
const flowSteps = [
  "Consult",
  "Survey",
  "Design",
  "Approvals",
  "Procurement",
  "Install",
  "Maintain",
];

export default function ProcessFlow() {
  return (
    <Box px={{ base: 4, md: 20 }} py={16} bg="#F5FAF6">
      <Text
        textAlign="center"
        fontSize={{ base: "2xl", md: "4xl" }}
        fontWeight="bold"
        color="#519C36"
        mb={12}
      >
        Our Process Flow
      </Text>

      <Flex
        direction={{ base: "column", md: "row" }}
        align="center"
        justify="space-between"
        wrap="wrap"
        gap={8}
      >
        {flowSteps.map((step, idx) => (
          <MotionBox
            key={step}
            bg="white"
            rounded="2xl"
            p={6}
            shadow="xl"
            minW={{ base: "100%", md: "120px" }}
            textAlign="center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: idx * 0.1, type: "spring", stiffness: 80 }}
            position="relative"
          >
            <VStack spacing={2}>
              <Box
                w="50px"
                h="50px"
                bg="#519C36"
                color="white"
                rounded="full"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontWeight="bold"
                fontSize="lg"
              >
                {idx + 1}
              </Box>
              <Text fontWeight="semibold" color="#305D24">
                {step}
              </Text>
            </VStack>

            {/* Connector Arrow for desktop */}
            {idx < flowSteps.length - 1 && (
              <Box
                display={{ base: "none", md: "block" }}
                position="absolute"
                top="50%"
                right="-60px"
                w="60px"
                h="4px"
                bg="#F6A11A"
                transform="translateY(-50%)"
              />
            )}

            {/* Connector Arrow for mobile */}
            {idx < flowSteps.length - 1 && (
              <Box
                display={{ base: "block", md: "none" }}
                position="absolute"
                bottom="-40px"
                left="50%"
                w="4px"
                h="40px"
                bg="#F6A11A"
                transform="translateX(-50%)"
              />
            )}
          </MotionBox>
        ))}
      </Flex>
    </Box>
  );
}
